import { render, staticRenderFns } from "./DateChooser.vue?vue&type=template&id=f1da0052&scoped=true"
import script from "./DateChooser.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateChooser.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DateChooser.vue?vue&type=style&index=0&id=f1da0052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1da0052",
  null
  
)

export default component.exports